(function () {
  function initialiseCollectionsIndex(root) {
    if (!root || root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    var grid = root.querySelector('[data-collections-grid]');
    var search = root.querySelector('[data-collections-search]');
    var sort = root.querySelector('[data-collections-sort]');
    var toggles = root.querySelectorAll('[data-collections-view]');
    var empty = root.querySelector('[data-collections-empty]');
    if (!grid) return;

    var storageKey = 'icarus:collections-view:v1';
    var defaultView = root.dataset.defaultView === 'list' ? 'list' : 'grid';
    var view = defaultView;

    try {
      var savedView = window.localStorage.getItem(storageKey);
      if (savedView === 'grid' || savedView === 'list') view = savedView;
    } catch (error) {
      view = defaultView;
    }

    function setView(nextView) {
      view = nextView === 'list' ? 'list' : 'grid';
      grid.dataset.view = view;
      toggles.forEach(function (button) {
        var selected = button.dataset.collectionsView === view;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      try { window.localStorage.setItem(storageKey, view); } catch (error) {}
    }

    function updateResults() {
      var query = search ? search.value.trim().toLowerCase() : '';
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-collection-item]'));
      var visibleCount = 0;

      cards.forEach(function (card) {
        var matches = !query || card.dataset.collectionSearch.indexOf(query) !== -1;
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      var direction = sort ? sort.value : 'az';
      cards.sort(function (a, b) {
        if (direction === 'za') return b.dataset.collectionTitle.localeCompare(a.dataset.collectionTitle);
        if (direction === 'count-desc') return Number(b.dataset.collectionCount) - Number(a.dataset.collectionCount);
        if (direction === 'count-asc') return Number(a.dataset.collectionCount) - Number(b.dataset.collectionCount);
        return a.dataset.collectionTitle.localeCompare(b.dataset.collectionTitle);
      });
      cards.forEach(function (card) { grid.appendChild(card); });
      if (empty) empty.hidden = visibleCount !== 0;
    }

    toggles.forEach(function (button) {
      button.addEventListener('click', function () { setView(button.dataset.collectionsView); });
    });
    if (search) search.addEventListener('input', updateResults);
    if (sort) sort.addEventListener('change', updateResults);

    setView(view);
    updateResults();
  }

  document.querySelectorAll('[data-collections-index]').forEach(initialiseCollectionsIndex);
  document.addEventListener('shopify:section:load', function (event) {
    initialiseCollectionsIndex(event.target.querySelector('[data-collections-index]'));
  });
})();
